// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hCG0v","icon":"styles_icon__1Uons"};